import { createContext } from "react";
import { configure, makeAutoObservable, } from 'mobx';
import IPublic from "@/interface/public";
import { ConfDoEntrys, ConfDoEntrysTasks } from '@/interface/request.interface'
import { random } from "@/utils/util";

configure({ useProxies: "never" })

class Store {
  _rootStore;

  constructor(_rootStore: any) {
    this._rootStore = _rootStore
    makeAutoObservable(this)
  }

  // 是否没参与过活动
  noParticipate: boolean = true

  setNoParticipate(bool: boolean) {
    this.noParticipate = bool
  }

  updateParticipate: () => void = () => {}

  setUpdateParticipate(fn: () => void) {
    this.updateParticipate = fn;
  }

  urlParams: IPublic.UrlParams = {
    QD: ['', ''],
    AW: ['', ''],
    pro: 'yygame',
    HD: ['', '']
  }

  setUrlParams(data: IPublic.UrlParams) {
    this.urlParams = data;
  }

  // 是否登录
  isLogin: boolean | undefined = undefined

  setLogin(bool: boolean) {
    this.isLogin = bool;
  }

  // 用户信息
  userInfo: IPublic.UserInfo | null = null

  setUserInfo(data: IPublic.UserInfo) {
    this.userInfo = data;
  }

  // 是否处于浏览器环境
  get isBrowser() {
    let proName = '';

    try {
      // @ts-ignore
      proName = window?.external?.getClientProName();
    } catch (e) {
      proName = '';
    }

    return !!!proName
  }
}

class Operate {
  _rootStore;

  constructor(_rootStore: any) {
    this._rootStore = _rootStore
    makeAutoObservable(this)
  }

  /******************************************************** */

  /** 每日免费奖励任务
   * [task1, 2, 3]
   * */
  dayFreeTask: ConfDoEntrysTasks[] = [];

  setDayFreeTask(data: ConfDoEntrysTasks[]) {
    this.dayFreeTask = data;
  }

  // 每日免费-奖励
  dayFreeAward: ConfDoEntrysTasks[] = []

  setDayFreeAward(data: ConfDoEntrysTasks[]) {
    this.dayFreeAward = data;
  }

  // 三个入口的游戏列表
  dayFreeGameEntry: ConfDoEntrys['upgs'][] = [];

  setDayFreeGameEntry(data: ConfDoEntrys['upgs'][]) {
    this.dayFreeGameEntry = data;
  }

  // 随机的游戏索引
  randomEntryGameIdx: number | undefined = undefined

  setRandomEntryGameIdx(data: number) {
    this.randomEntryGameIdx = data;
  }
  // 随机的游戏
  randomEntryGame: ConfDoEntrys['upgs'] | null = null

  setRandomEntryGame(data: ConfDoEntrys['upgs']) {
    this.randomEntryGame = data;
  }

  // 选中的奖品索引
  checkAwardIdx: undefined | 0 | 1 | 2 = undefined;

  setCheckAwardIdx(index: 0 | 1 | 2) {
    this.checkAwardIdx = index
  }

  /******************************************************** */
  dayRechargeTask: ConfDoEntrysTasks[][] = []

  setDayRechargeTask(data: ConfDoEntrysTasks[][]) {
    this.dayRechargeTask = data;
  }

  /******************************************************** */

    // 月日充值-任务
  initMonthRecharge: () => void = () => {}

  setMonthRechargeTask(data: () => void) {
    this.initMonthRecharge = data;
  }
}

class RootStore {
  store;
  operate;

  constructor() {
    this.store = new Store(this);
    this.operate = new Operate(this);
  }
}

const rootStore = new RootStore();
const MobxContext = createContext(rootStore);

export {
  rootStore,
  MobxContext
};
